import { render, staticRenderFns } from "./pendamping-pmptsp.vue?vue&type=template&id=133f7387&scoped=true"
import script from "./pendamping-pmptsp.vue?vue&type=script&lang=js"
export * from "./pendamping-pmptsp.vue?vue&type=script&lang=js"
import style0 from "./pendamping-pmptsp.vue?vue&type=style&index=0&id=133f7387&prod&lang=scss"
import style1 from "./pendamping-pmptsp.vue?vue&type=style&index=1&id=133f7387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f7387",
  null
  
)

export default component.exports